// v1.2.0 — the part of MNote (v2.2, series A) the app talks to, and the
// EIP-712 TransferNote intent a secret-derived key signs. The contract is
// contracts/src/MNote.sol; domain "MNote" / "1" / chain id / the contract.

const NOTE_TUPLE = {
  type: "tuple",
  components: [
    { name: "value", type: "uint96" },
    { name: "controller", type: "address" },
    { name: "version", type: "uint64" },
    { name: "seq", type: "uint64" },
    { name: "status", type: "uint8" },
    { name: "salt", type: "bytes32" },
  ],
} as const;

export const MNOTE_ABI = [
  {
    type: "function", name: "issueNote", stateMutability: "nonpayable",
    inputs: [{ name: "to", type: "address" }, { name: "amount", type: "uint96" }, { name: "salt", type: "bytes32" }],
    outputs: [{ name: "noteId", type: "bytes32" }],
  },
  {
    type: "function", name: "transferNote", stateMutability: "nonpayable",
    inputs: [
      { name: "noteId", type: "bytes32" }, { name: "to", type: "address" },
      { name: "expectedVersion", type: "uint64" }, { name: "amount", type: "uint96" },
    ],
    outputs: [],
  },
  {
    type: "function", name: "transferNoteBySig", stateMutability: "nonpayable",
    inputs: [
      { name: "noteId", type: "bytes32" }, { name: "to", type: "address" },
      { name: "expectedVersion", type: "uint64" }, { name: "amount", type: "uint96" },
      { name: "deadline", type: "uint256" }, { name: "sig", type: "bytes" },
    ],
    outputs: [],
  },
  {
    type: "function", name: "redeemNote", stateMutability: "nonpayable",
    inputs: [
      { name: "noteId", type: "bytes32" }, { name: "usdcRecipient", type: "address" },
      { name: "expectedVersion", type: "uint64" }, { name: "amount", type: "uint96" },
    ],
    outputs: [],
  },
  {
    type: "function", name: "noteBySeq", stateMutability: "view",
    inputs: [{ name: "seq", type: "uint256" }],
    outputs: [{ name: "noteId", type: "bytes32" }, { name: "n", ...NOTE_TUPLE }],
  },
  {
    type: "function", name: "notesOfWithState", stateMutability: "view",
    inputs: [{ name: "controller", type: "address" }],
    outputs: [
      { name: "ids", type: "bytes32[]" },
      { name: "notes", type: "tuple[]", components: NOTE_TUPLE.components },
    ],
  },
] as const;

export const ERC20_APPROVE_ABI = [
  {
    type: "function", name: "approve", stateMutability: "nonpayable",
    inputs: [{ name: "spender", type: "address" }, { name: "amount", type: "uint256" }],
    outputs: [{ type: "bool" }],
  },
] as const;

/** 1.4.68 — the 2¢ of gas a note carries for its own key (ArcNoteSource.issueCalls): a plain transfer of USDC, Arc's gas. */
export const ERC20_TRANSFER_ABI = [
  {
    type: "function", name: "transfer", stateMutability: "nonpayable",
    inputs: [{ name: "to", type: "address" }, { name: "amount", type: "uint256" }],
    outputs: [{ type: "bool" }],
  },
] as const;

/** EIP-712: what a controller signs to hand a note over through transferNoteBySig. */
export const TRANSFER_NOTE_TYPES = {
  TransferNote: [
    { name: "noteId", type: "bytes32" },
    { name: "version", type: "uint64" },
    { name: "newController", type: "address" },
    { name: "amount", type: "uint96" },
    { name: "deadline", type: "uint256" },
  ],
} as const;

export const NOTE_DOMAIN_NAME = "MNote";
export const NOTE_DOMAIN_VERSION = "1";

/** Whole dollars: every value and amount on the contract is a multiple of this (6 dp). */
export const UNIT = 1_000_000n;
